import { storePath } from "./storeUrl";

export const cleanWa = (n = "") => String(n).replace(/[^0-9]/g, "");
export const waLink = (num = "", msg = "") =>
  `https://wa.me/${cleanWa(num)}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;
export const isWa = (n = "") => /^\+?[0-9]{8,15}$/.test(String(n).trim());
export const isUrl = (u = "") => /^https?:\/\/[^\s]+$/i.test(String(u).trim());

const YT_RE = /(?:youtube\.com\/(?:watch\?[^#]*v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/;
export const ytId = (url = "") => { const m = String(url).match(YT_RE); return m ? m[1] : ""; };
export const isYouTube = (url = "") => !!ytId(url);
export const ytThumb = (url = "") => { const id = ytId(url); return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : ""; };

export const INTERNAL_PAGES = [
  ["home", "Home page"], ["shop", "Shop / Products"], ["cart", "Cart"],
  ["account", "My Account"], ["contact", "Contact section"],
];

export const BUTTON_TYPES = [
  ["none", "No link"], ["whatsapp", "WhatsApp"], ["url", "External URL"],
  ["payment", "Payment Link"], ["page", "Internal Page"], ["service", "Service Details Page"],
];

/* Resolve a card's CTA config into a concrete link. Returns null when not configured. */
export function resolveCta(cfg = {}, { slug = "" } = {}) {
  const t = cfg.buttonType || "none";
  if (t === "whatsapp") {
    if (!isWa(cfg.whatsappNumber)) return null;
    return { href: waLink(cfg.whatsappNumber, cfg.whatsappMessage), external: true };
  }
  if (t === "url" || t === "payment") {
    if (!isUrl(cfg.buttonUrl)) return null;
    return { href: String(cfg.buttonUrl).trim(), external: true };
  }
  if (t === "page") {
    const map = { home: "/", shop: "/shop", cart: "/cart", account: "/account", contact: "/#site-contact" };
    return { href: storePath(slug, map[cfg.page] || "/"), external: false };
  }
  if (t === "service") {
    if (!cfg.id) return null;
    return { href: storePath(slug, `/service/${cfg.id}`), external: false };
  }
  return null;
}

const priceOk = (v) => !String(v || "").trim() || /[0-9]/.test(String(v));

/* Product-selling websites (store type ecommerce) — service/pricing defaults & palette entries do not apply. */
export const isEcommerceSite = (website = {}, theme = {}) => {
  if (website?.type === "ecommerce") return true;
  const wt = theme?.website_types;
  return Array.isArray(wt) && wt.includes("ecommerce");
};

/* Scan an editor doc and return blocking issues (invalid CTAs, prices, YouTube URLs). */
export function validateDoc(doc) {
  const errs = [];
  for (const sec of doc?.sections || []) {
    if (sec.hidden) continue;
    const p = sec.props || {};
    const label = p.title || sec.type;
    const cards = sec.type === "services" ? p.cards : sec.type === "pricing" ? p.packages : null;
    if (Array.isArray(cards)) cards.forEach((c, i) => {
      const nm = String(c.name || "").trim() || `Card ${i + 1}`;
      if (!String(c.name || "").trim()) errs.push({ sectionId: sec.id, msg: `${label}: card ${i + 1} is missing a name` });
      const bt = c.buttonType || "none";
      if (bt === "whatsapp" && !isWa(c.whatsappNumber))
        errs.push({ sectionId: sec.id, msg: `${label} › ${nm}: invalid WhatsApp number (use country code, digits only, e.g. 919876543210)` });
      if ((bt === "url" || bt === "payment") && !isUrl(c.buttonUrl))
        errs.push({ sectionId: sec.id, msg: `${label} › ${nm}: button link must start with http:// or https://` });
      if (!priceOk(c.price) || !priceOk(c.offerPrice))
        errs.push({ sectionId: sec.id, msg: `${label} › ${nm}: price should contain an amount (digits)` });
    });
    if (sec.type === "youtube") (p.videos || []).forEach((v, i) => {
      if (v.active === false) return;
      const u = String(v.youtubeUrl || "").trim();
      if (u && !isYouTube(u))
        errs.push({ sectionId: sec.id, msg: `${label}: video ${i + 1} ("${v.title || "untitled"}") has an invalid YouTube URL` });
    });
  }
  return errs;
}
